import { Data } from './data';

export class Badge extends Data {
    class: string = "Badge";
    tag: string;
    name: string;
    id: string;
}